<script lang="ts">
	import { page } from '$app/stores';
	import { error } from '@sveltejs/kit';
	import FacebookLogo from '$components/PlatformLogos/FacebookLogo.svelte';
	import TwitterLogo from '$components/PlatformLogos/TwitterLogo.svelte';
	import YoutubeLogo from '$components/PlatformLogos/YoutubeLogo.svelte';
	import InstagramLogo from '$components/PlatformLogos/InstagramLogo.svelte';
	import RssLogo from '$components/PlatformLogos/RssLogo.svelte';
	import PodcastLogo from '$components/PlatformLogos/PodcastLogo.svelte';
	import NewsletterLogo from '$components/PlatformLogos/NewsletterLogo.svelte';

	interface FollowLink {
		platform: string;
		url: string;
	}

	let followUsLinks: FollowLink[];

	if (!$page.data.textData) {
		throw error(500, {
			message: 'No `textData` found in ArchieML file',
			file: 'FollowUsButtons.svelte',
		});
	}

	if ($page.data.textData.ui.navbar.follow) {
		followUsLinks = $page.data.textData.ui.navbar.follow.links;
	} else {
		throw error(500, {
			message: 'Follow Us links not found in ArchieML file',
			file: 'FollowUsButtons.svelte',
		});
	}
</script>

<div class="follow-section">
	{#each followUsLinks as link}
		<div class="follow-button">
			{#if link.platform === 'facebook'}
				<FacebookLogo url="{link.url}" />
			{/if}
			{#if link.platform === 'twitter'}
				<TwitterLogo url="{link.url}" />
			{/if}
			{#if link.platform === 'youtube'}
				<YoutubeLogo url="{link.url}" />
			{/if}
			{#if link.platform === 'instagram'}
				<InstagramLogo url="{link.url}" />
			{/if}
			{#if link.platform === 'rss'}
				<RssLogo url="{link.url}" />
			{/if}
			{#if link.platform === 'podcasts'}
				<PodcastLogo url="{link.url}" />
			{/if}
			{#if link.platform === 'newsletters'}
				<NewsletterLogo url="{link.url}" />
			{/if}
		</div>
	{/each}
</div>

<style lang="scss">
	.follow-section {
		grid-gap: 10px; // Adjust as needed
		display: grid;
		grid-template-columns: repeat(
			auto-fit,
			minmax(50px, 1fr)
		); // Adjust as needed
		padding-top: 16px;
	}
	.follow-button {
		display: flex;
		align-items: center; // centers vertically
	}
</style>
